/* App.js */

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";

import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";
import Cookies from "js-cookie";

import store from "./Redux/store";
import LoginPage from "./login/Loginpage";
import Layout from "./Layout/Layout";
import DebugBlocked from "./page/DebugBlocked/DebugBlocked"
import VoiceAssistant from "./components/VoiceAssistant/VoiceAssistant";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const [isClient, setIsClient] = useState(false);
  const [apiBlocked, setApiBlocked] = useState(false);

  // ---------------- 🛑 Detect Mobile Device ---------------- //
  const isMobileDevice = () => {
    return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(
      navigator.userAgent
    );
  };

  // ----------- 🚨 DEVTOOLS DETECTION --------------- //
  const detectDevTools = () => {
    if (isMobileDevice()) return false;

    const threshold = 160;

    const windowSizeDiff =
      window.outerHeight - window.innerHeight > threshold ||
      window.outerWidth - window.innerWidth > threshold;

    const debuggerDetected = () => {
      let detected = false;

      const start = performance.now();
      debugger;
      const end = performance.now();

      if (end - start > 100) {
        detected = true;
      }

      return detected;
    };

    const consoleTampered =
      !console.log || typeof console.log !== "function";

    return windowSizeDiff || debuggerDetected() || consoleTampered;
  };

  // ----------- 🚨 INTERCEPT API CALLS --------------- //
  const interceptAPICalls = () => {
    const originalFetch = window.fetch;

    window.fetch = function (...args) {
      if (apiBlocked) {
        return Promise.reject(
          new Error("API calls blocked - Debug mode detected")
        );
      }

      return originalFetch.apply(this, args);
    };
  };

  // ----------- 🚫 DISABLE RIGHT CLICK --------------- //
  const disableRightClick = () => {
    const handleContextMenu = (e) => e.preventDefault();

    document.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  };

  useEffect(() => {
    setIsClient(true);

    interceptAPICalls();

    const cleanupRightClick = disableRightClick();

    // ------------ 🛑 Disable Shortcuts ---------- //
    const handleKeyDown = (e) => {
      if (isMobileDevice()) return;

      // F12
      if (e.key === "F12") {
        e.preventDefault();
        setApiBlocked(true);
      }

      // Ctrl + Shift + I/J/C
      if (
        e.ctrlKey &&
        e.shiftKey &&
        ["i", "j", "c"].includes(e.key.toLowerCase())
      ) {
        e.preventDefault();
        setApiBlocked(true);
      }

      // Ctrl + U
      if (e.ctrlKey && e.key.toLowerCase() === "u") {
        e.preventDefault();
        setApiBlocked(true);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    // ----------- 🛑 Check DevTools ---------- //
    const checkDevTools = () => {
      if (!isMobileDevice() && detectDevTools()) {
        setApiBlocked(true);
      }
    };

    const interval = setInterval(checkDevTools, 500);

    if (detectDevTools()) {
      setApiBlocked(true);
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);

      clearInterval(interval);

      cleanupRightClick();
    };
  }, []);

  useEffect(() => {
    interceptAPICalls();
  }, [apiBlocked]);

  if (!isClient) return null;

  const token = Cookies.get("authToken");

  return (
    <>
      <Provider store={store}>
        {!apiBlocked ? (
          token ? (
            <>
              <Layout />
              <VoiceAssistant />
            </>
          ) : (
            <LoginPage />
          )
        ) : (
          <DebugBlocked />
        )}
      </Provider>
      <ToastContainer />
    </>
  );
}

export default App;